import api from '../../../store/config/api';
import { APP_LIST as SCHEMA } from '../../../schemas';

export const [
  GET_APPS,
  GET_APPS_REQUEST,
  GET_APPS_SUCCESS,
  GET_APPS_FAILURE
] = api.buildTypes('GET_APPS');

export function getApps({
  teamName,
  action,
  integrationDefinition,
  includeSharedApps = true,
  includeDraftApps = false
}) {
  let url = `/teams/${teamName}/apps?includeSharedApps=${includeSharedApps}`;
  if (includeDraftApps) {
    url += '&includeDrafts=true';
  }
  if (integrationDefinition) {
    url += '&integrationDefinition=true';
  }
  if (action) {
    url += `&action=${action}`;
  }
  return {
    type: GET_APPS,
    payload: {
      url,
      schema: SCHEMA,
      options: {
        method: 'GET'
      }
    }
  };
}

export function getAppByAppName({ teamName, appName }) {
  let url = `/teams/${teamName}/apps/${appName}`;
  return {
    type: GET_APPS,
    payload: {
      url,
      schema: SCHEMA,
      options: {
        method: 'GET'
      }
    }
  };
}

export function getAuthableApps({ teamName, includeDraftApps }) {
  return getApps({
    teamName,
    integrationDefinition: true,
    includeSharedApps: true,
    includeDraftApps
  });
}



// WEBPACK FOOTER //
// ./js/actions/api/apps/index.js